import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Button, MenuItem } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';

import Box from '@material-ui/core/Box';

import {
    Update as UPDATE,
    SelectByID as SELECT_BY_ID
} from 'Components/Api/CommissionHoldAPI';

import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const Action = ({ RedeemcommissionID, onDismissCallback }) => {
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [RequestObject, setRequestObject] = useState({
        RedeemcommissionID: RedeemcommissionID,
        LastYearMonth: '',
        DOC: '',
        FirmName: '',
        Amount: 0,
        Status: '0',
        UserRemark: '',
        AdminRemark: '',
        WalletID: 0
    });

    const validationSchema = Yup.object({
        AdminRemark: Yup.string().required(PLEASE_PROVIDE_VALID + 'remark'),
        Status: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'Status')
            .required(PLEASE_SELECT_VALID + 'Status')
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setLoadingOpen(true);

        var response = await UPDATE(JSON.stringify(values));

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);

        if (!response.status) {
            setSeverity('error');
            setLoadingOpen(false);
            return;
        }

        setTimeout(() => {
            onDismissCallback(false);
        }, MESSAGE_CLOSE_AFTER);
    };

    useEffect(() => {
        GetTransactionByID(RedeemcommissionID);
    }, []);

    const GetTransactionByID = async (RedeemcommissionID) => {
        setLoadingOpen(true);

        let jsonObj = {
            RedeemcommissionID: RedeemcommissionID
        };
        var request = JSON.stringify(jsonObj);

        let response = await SELECT_BY_ID(request);
        setLoadingOpen(false);

        let data = JSON.parse(response.data);

        setRequestObject({
            ...RequestObject,
            LastYearMonth: data.LastYearMonth,
            FirmName: data.FirmName,
            Amount: data.Amount,
            UserRemark: data.UserRemark,
            DOC: data.TransactionDate,
            WalletID: data.WalletID
        });
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={RequestObject}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={RequestObject}
            >
                {(formProps) => {
                    return (
                        <Form>
                            <Grid container spacing={3}>
                                <Grid item xs={2}>
                                    <MaterialTextField
                                        name="LastYearMonth"
                                        label="Year-Month"
                                        placeholder="Year-Month"
                                        readOnly={true}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <MaterialTextField
                                        label="FirmName"
                                        name="FirmName"
                                        type="text"
                                        title="FirmName"
                                        readOnly={true}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <MaterialNumberField
                                        name="Amount"
                                        label="Amount"
                                        readOnly={true}
                                        placeholder="Amount"
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <MaterialTextField
                                        label="Admin Remark"
                                        name="AdminRemark"
                                        type="text"
                                        title="Admin Remark"
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <MaterialSelect
                                        label="Status"
                                        name="Status"
                                        title="Status"
                                    >
                                        <MenuItem key="0" value="0">
                                            Select Status
                                        </MenuItem>

                                        <MenuItem key="SUCCESS" value="SUCCESS">
                                            ACCEPT
                                        </MenuItem>
                                        <MenuItem key="FAILURE" value="FAILURE">
                                            REJECT
                                        </MenuItem>
                                    </MaterialSelect>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <div
                                    style={{
                                        color: 'green',
                                        marginBottom: '15px'
                                    }}
                                >
                                    Note : Request Status "ACCEPT" means
                                    Commission hold amount transfer to retailer
                                    <br /> Request status "REJECT" means no
                                    transfer.
                                </div>
                            </Grid>
                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Submit"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loadingOpen}
                                        >
                                            Submit
                                        </Button>
                                        {loadingOpen && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
